'use client';
import { classNames } from '@lib/classNames/classNames';
import NextLink from 'next/link';

import { LinkProps } from './types';

export const Link = ({
  variant = 'medium',
  children,
  href,
  className,
  labelLink,
}: LinkProps) => {
  const isExternalLink = href.startsWith('http') || href.startsWith('//');

  return (
    <NextLink
      itemProp="url"
      href={href}
      aria-label={labelLink || ''}
      target={isExternalLink ? '_blank' : '_self'}
      className={classNames(
        'cursor-pointer',
        {
          '': variant === 'default',
          'text-sm text-textBaseTertiary hover:text-statusAccent':
            variant === 'small',
          'text-base text-textBaseSecondary hover:text-statusAccent':
            variant === 'medium',
          'font-medium text-textBasePrimary hover:text-statusAccent':
            variant === 'large',
        },
        [className],
      )}
    >
      <span itemProp="name">{children}</span>
    </NextLink>
  );
};
